var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
        'box-border rounded-lg border px-10 py-4 text-center transition-all duration-200',
        _vm.active
            ? 'border-2 border-primary bg-[rgba(182,209,196,0.3)]'
            : 'm-[1px] border border-neutral-lighter',
    ],attrs:{"type":"button"},on:{"click":_vm.toggleClick}},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }